<div class="flex flex-column gap-2" [formGroup]="form">
 <!--  <app-input-text name="nomenclatura" label="Nomenclatura" [form]="form"></app-input-text> -->
  <app-input-text name="parametro" label="Parametro" [form]="form"></app-input-text>
  <app-input-text name="definizione" label="Definizione" [form]="form"></app-input-text>
  <app-input-text name="unitaDiMisura" label="Unita di misura" [form]="form"></app-input-text>
  <app-input-text name="note" label="Note" [form]="form"></app-input-text>
<!--   <app-input-toggle name="isCodificato" label="Codificato" [form]="form"></app-input-toggle> -->
</div>
